import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/auth'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Swarms from './pages/Swarms'
import SwarmDetail from './pages/SwarmDetail'
import CreateSwarm from './pages/CreateSwarm'
import Agents from './pages/Agents'
import Settings from './pages/Settings'
import Login from './pages/Login'
import NotFound from './pages/NotFound'

function App() {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/swarms" element={<Swarms />} />
        <Route path="/swarms/create" element={<CreateSwarm />} />
        <Route path="/swarms/:id" element={<SwarmDetail />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  )
}

export default App
